import React from 'react'

const AboutUpdated = () => {
  return (
    <div className='px-24 pt-32 pb-10 h-[48rem] w-screen overflow-hidden'>
        <div className='flex'>
            <div className='flex flex-col gap-5 mt-8'>
                <span><hr className='h-2 w-28 bg-[#273773]'/></span>
                <span className='flex flex-col text-5xl w-[40rem] tracking-wider font-medium gap-1'>
                    <span className='op'>Your go to agency </span>
                    <span className=''>providing marketing & </span>
                    <span className=''>business support solutions.</span>
                    <span className=''>Creative {'>'} PR {'>'} Strategy</span>
                </span>
                <span className='text-lg font-light tracking-wider opacity-80 w-[32rem]'>Vyda Agency isn't just a marketing agency; it's a powerhouse of creativity, PR mastery, and strategic brilliance. We don't just provide services; we equip our clients with a toolkit that empowers them to focus on what truly matters - realizing their full potential.</span>
                <span className='px-6 py-2 rounded-lg font-normal text-base bg-[#273773] text-white/90 w-fit'>About Us</span>
            </div>
            <div className='flex'>
                <span className='w-80 h-60 bg-black/95 rounded-tl-[2rem] rounded-tr-xl rounded-br-[2rem] rounded-bl-xl -left-36 flex top-[22rem] relative z-50'></span>
                <span className='w-[26rem] h-[38rem] bg-[#273773] rounded-tr-[3rem] rounded-bl-[3rem] flex relative -left-56'></span>
            </div>
        </div>
    </div>
  )
}

export default AboutUpdated;